import React from 'react';

import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';

const SupervisorIcon = ()=> (<SupervisorAccountIcon/>)

export default SupervisorIcon;
